<template>
  <div
    :class="['notifications-area', { 'notifications-area--open': showNotifs }]"
  >
    <ElPopover
      trigger="click"
      placement="bottom"
      popper-class="notifications-area__popover"
      transition="el-zoom-in-top"
      @show="sendNotifSeen"
      @hide="onPopoverClose"
    >
      <CardApiError
        v-if="apiError"
        :error-text="$t('NOTIFICATIONS_AREA.API_ERROR')"
        wrapper-class=""
        @retry="getNotifs"
      />

      <ul
        v-else-if="notifs.length"
        v-loading="isLoading"
        class="notifications-area__messages"
      >
        <li
          is="NotificationMessage"
          v-for="notif in notifs"
          :key="notif.id"
          :title="notif.title"
          :text="notif.text"
          :button-text="notif.button"
          :button-link="notif.buttonLink"
          :is-seen="notif.isSeen"
        />
      </ul>
      <div v-else class="text-center">
        {{ $t('NOTIFICATIONS_AREA.EMPTY') }}
      </div>
      <ElBadge slot="reference" :hidden="!newNotifs" :value="newNotifs">
        <ElButton class="notifications-area__button" size="medium">
          <i class="notifications-area__icon el-icon-message-solid" />
          <template v-if="label">
            {{ label }}
          </template>
        </ElButton>
      </ElBadge>
    </ElPopover>
  </div>
</template>

<script>
import NotificationMessage from './NotificationMessage';
import Notifications from '@/api/notifications';
import CardApiError from '@@/common/CardApiError';

export default {
  name: 'NotificationsArea',

  components: {
    NotificationMessage,
    CardApiError,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showNotifs: false,
      isLoading: true,
      notifs: [],
      apiError: false,
    };
  },

  computed: {
    newNotifs() {
      return this.notifs.filter(notif => !notif.isSeen).length;
    },
  },

  created() {
    this.getNotifs();
  },

  methods: {
    getNotifs() {
      this.isLoading = true;
      this.apiError = false;
      return Notifications.get()
        .then(notifications => {
          this.notifs = notifications;
        })
        .catch(() => {
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    sendNotifSeen() {
      this.showNotifs = true;

      if (this.newNotifs) {
        const lastNotifID = this.notifs[0].id;
        return Notifications.sendSeen(lastNotifID);
      }
    },

    onPopoverClose() {
      this.showNotifs = false;
      if (this.newNotifs) {
        this.notifs = this.notifs.map(notif => ({ ...notif, isSeen: true }));
      }
    },
  },
};
</script>

<style lang="scss">
.notifications-area {
  $base: &;

  &__button {
    background: none !important;
    border: 0 !important;
    transition: all 0.4s;
    font-weight: 100 !important;
    color: $white !important;
    font-size: $lb-side-nav-font-size !important;
  }

  &--open {
    #{$base}__button {
      background: rgba(#fff, 0.3) !important;
    }
  }

  &__icon {
    font-size: 1.4rem;
    vertical-align: middle !important;
  }

  .el-badge__content {
    right: 19px !important;
    top: 12px !important;
  }

  &__title {
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: $global-margin;
  }

  &__messages {
    margin: 0;
    padding: 0;
    min-height: rem-calc(100);
    max-height: 60vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 10px;
    }
  }

  &__popover {
    width: 100%;
    max-width: 400px;
    top: rem-calc(45) !important;
    @include breakpoint(small only) {
      left: 0 !important;
    }

    &::-webkit-scrollbar {
      border-radius: 100px;
      width: 8px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background: #f1f1f1;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 100px;
    }
  }
}
</style>
